<template>
  <div class="home">
    <v-parallax src="@/assets/banner_hero.png" height="500">
      <v-layout column align-center justify-center class="white--text">
        <h1 class="white--text mb-2 display-3 text-center text-uppercase">
          DES-IF Campinas
        </h1>
        <div class="subheading mb-4 text-center">
          <p>
            Declaração Eletrônica de Serviços - Instituição Financeira
          </p>
        </div>
        <div class="subheading mb-4 text-center hidden-sm-and-down">
          <v-layout wrap align-center justify-center class="white--text">
            <v-flex class="ma-1" xs12 md12>
              <v-icon class="white--text" x-large>airplay</v-icon>
              <div class="title">Entrar</div>
              <v-divider dark></v-divider>
              <div class="font-weight-thin">
                Acesso exclusivo <br> com certificado digital.<br>Clique para entrar
              </div>
              <v-btn small class="mt-2" outlined dark router to="login">
                <v-icon small left>exit_to_app</v-icon>
                <span>Entrar</span>
              </v-btn>
            </v-flex>
            <!-- <v-flex class="ma-1" xs12 md3>
              <v-icon class="white--text" x-large>lock</v-icon>
              <div class="title">1º Acesso</div>
              <v-divider dark></v-divider>
              <div class="font-weight-thin">
                Se já tiver CPF/CNPJ cadastrado na Prefeitura, mas ainda não
                recebeu sua senha de acesso, solicite agora mesmo.
              </div>
              <v-layout>
                <v-flex xs12 md6 class="pr-2">
                  <v-btn small class="mt-2" outlined dark router to="senha">
                    <span>Solicitar senha</span>
                  </v-btn>
                </v-flex>
                <v-flex xs12 md6>
                  <v-btn
                    small
                    dark
                    class="mt-2"
                    color="teal lighten-1"
                    router
                    to="recuperarEmail"
                  >
                    <span>Atualizar e-mail</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex> -->
            <!-- <v-flex class="ma-1" xs12 md4>
              <v-icon class="white--text" x-large>contact_mail</v-icon>
              <div class="title">Cadastro</div>
              <v-divider dark></v-divider>
              <div class="font-weight-thin">Exclusivamente para pessoa natural representante de Instituição Financeira estabelecida no Município de Campinas e para Instituição Financeira estabelecida em outro município responsável pela transmissão das declarações de Instituição Financeira estabelecida no Município
              </div>
              <v-btn small class="mt-2" outlined dark :href="linkCadastro">
                <v-icon small left>account_box</v-icon>
                <span>Fazer cadastro</span>
              </v-btn>
            </v-flex> -->
          </v-layout>
        </div>
      </v-layout>
    </v-parallax>

    <section>
      <v-layout column wrap class="my-12" align-center>
        <!-- <v-flex xs12 sm4 class="my-4">
          <div class="text-center">
            <h2 class="display-2">O que é a Nota Fiscal Eletrônica?</h2>
            <br />
            <p class="subheading grey--text px-10">
              A Nota Fiscal de Serviços Eletrônica é o documento fiscal de
              existência apenas digital, emitido e armazenado eletronicamente em
              programa de computador da Prefeitura Municipal de Goiânia, com o
              objetivo de registrar eletronicamente as prestações de serviços
              sujeitas à tributação do Imposto Sobre Serviços de Qualquer
              Natureza – ISSQN.
            </p>
          </div>
        </v-flex> -->
        <v-flex xs12 sm4>
          <v-container grid-list-xl>
            <div class="text-center">
              <h2 class="display-1 my-3 font-weight-thin">
                A ferramenta ideal para <strong>Instituição Financeira</strong>
              </h2>
            </div>
            <v-divider></v-divider>
            <v-layout wrap>
              <v-flex xs12 md4>
                <v-card>
                  <v-img
                    class="white--text align-end"
                    src="@/assets/foto1.jpg"
                  />
                  <v-card-text>
                    <p class="title black--text text-center">Autenticação</p>
                    <span class="caption"
                      >A autenticação garantindo que apenas usuários autorizados possam acessar e realizar
                      operações. Este recurso fortalece a segurança do sistema, prevenindo acesso não autorizado.</span
                    >
                  </v-card-text>
                  <!-- <v-card-actions>
                    <v-btn text block small outlined :href="linkCadastro"
                      >Cadastrar-se</v-btn
                    >
                  </v-card-actions> -->
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card>
                  <v-img
                    class="white--text align-end"
                    src="@/assets/foto4.jpg"
                  />
                  <v-card-text>
                    <p class="title text-center black--text">Declaração</p>
                    <span class="caption"
                      >Modelo Conceitual DESIF da ABRASF. O uso do modelo conceitual ABRASF simplifica a declaração
                      de arquivos, tornando o processo mais padronizado e fácil de compreender.</span
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card>
                  <v-img
                    class="white--text align-end"
                    src="@/assets/foto5.jpg"
                  />
                  <v-card-text>
                    <p class="subtitle-1 black--text">Obrigações Fiscais</p>
                    <span class="caption"
                      >O sistema permite a emissão rápida e fácil da guia de recolhimento do ISS, 
                      facilitando o cumprimento das obrigações fiscais da instituição.</span
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
              <!-- <v-flex xs12 md3>
                <v-card>
                  <v-img
                    class="white--text align-end"
                    src="@/assets/foto6.jpg"
                  />
                  <v-card-text>
                    <p class="subtitle-1 black--text">
                      4. Guia de recolhimento
                    </p>
                    <span class="caption"
                      >Selecione o tipo de recolhimento e o mês de competência e
                      um quadro resumo com todas as notas pendentes de pagamento
                      será apresentado. Clique em “Emitir”.</span
                    >
                  </v-card-text>
                </v-card>
              </v-flex> -->
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      linkCadastro: "",
    };
  },
  created() {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = window.location.port == "8081" ? "8080" : window.location.port;    
    //const base_URL = `${protocol}//${hostname}:${port}/dec/paginas/credenciamento/listaCredenciamento.jsf`;
    const base_URL = `${protocol}//${hostname}:${port}/controleacesso/paginas/usuario/listaUsuarioExterno.jsf?multiTenantId=11&mostraCampoMatricula=N&faces-redirect=true`;
    this.linkCadastro = base_URL;
  },
};
</script>
